import React from 'react';

export default function CopyrightPage() {
  return (
    <div>
      <h2>Copyright & Trademarks</h2>
      <p>All Pokémon names, images and trademarks are the property of their respective owners. This project is a fan-made utility and is not affiliated with Nintendo, Game Freak, or The Pokémon Company.</p>
      <p>Assets in this demo are provided by PokéAPI and other community resources as noted in the credits.</p>
    </div>
  );
}
